.container {
  /* Justering på spacing slik at fokusmarkering osv. ikke skjules ved overflow */
  --dds-modal-content-padding: var(--dds-spacing-x0-25);
  --dds-modal-container-padding: var(--dds-spacing-x1)
    calc(var(--dds-spacing-x1) - var(--dds-modal-content-padding))
    calc(var(--dds-spacing-x1-5) - var(--dds-modal-content-padding))
    calc(var(--dds-spacing-x1-5) - var(--dds-modal-content-padding));

  padding: var(--dds-modal-container-padding);
}

.container-scrollable {
  max-height: calc(100vh - var(--dds-spacing-x1));
  overflow: auto;
}

.header-container {
  padding-bottom: calc(
    var(--dds-spacing-x0-75) - var(--dds-modal-content-padding)
  );
  z-index: 1;
}

.close-button {
  margin-left: auto;
  margin-top: calc(-1 * var(--dds-spacing-x0-125));
}

.content {
  padding-right: calc(var(--dds-spacing-x1) - var(--dds-modal-content-padding));
}

/* Spacing slik at fokusmarkering osv. ikke skjules ved overflow */
.body {
  padding: var(--dds-modal-content-padding);
}
